import { useCheckIfValueExistsInDisplayOptions } from '@/composables/useCheckIfValueExistsInDisplayOptions';
import { useGetDisplayOptionsClasses } from '@/composables/useGetDisplayOptionsClasses';
import { useParseDocumentToHtml } from '~/composables/useParseDocumentToHtml';
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'BlockTeaserText',
  components: {
    AzImg: AzImg
  },
  props: {
    title: String,
    images: Array,
    teaserRichtext: Object,
    secondRichtext: Object,
    displayOptions: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var options = {
      renderNode: {
        paragraph: function paragraph(node, next) {
          return "<p class=\"teaser\">".concat(next(node.content), "</p>");
        }
      }
    };
    var descriptionOptions = {
      renderNode: {
        paragraph: function paragraph(node, next) {
          return "<p class=\"description\" >".concat(next(node.content), "</p>");
        }
      }
    };
    var _useParseDocumentToHt = useParseDocumentToHtml(props.teaserRichtext, undefined, options),
      parsedTeaser = _useParseDocumentToHt.html;
    var _useParseDocumentToHt2 = useParseDocumentToHtml(props.secondRichtext, undefined, descriptionOptions),
      parsedDescription = _useParseDocumentToHt2.html;
    var isViewCollapsedByDefault = useCheckIfValueExistsInDisplayOptions('expanded-view', props.displayOptions);
    var readMoreActivated = ref(isViewCollapsedByDefault);
    function toggleReadMore() {
      readMoreActivated.value = !readMoreActivated.value;
    }
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    return {
      translate: translate,
      parsedTeaser: parsedTeaser,
      parsedDescription: parsedDescription,
      toggleReadMore: toggleReadMore,
      readMoreActivated: readMoreActivated,
      isViewCollapsedByDefault: isViewCollapsedByDefault,
      classes: classes
    };
  }
});